module.exports = __webpack_public_path__ + "media/images/newsletter-top-e61b7ef6da39753cae2beacfdf755aa2.jpg";